import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SendPosterButton } from "@/components/SendPosterButton";
import { toast } from "sonner";
import { Mail, Plus, X } from "lucide-react";

export const PosterMailSection = () => {
  const [emails, setEmails] = useState([]);
  const [posters, setPosters] = useState([]);
  const [draft, setDraft] = useState("");

  useEffect(() => {
    api.get("/poster-recipients").then(({ data }) => setEmails(data.emails));
    api.get("/posters").then(({ data }) => setPosters(data));
  }, []);

  const save = async (list) => {
    try {
      const { data } = await api.put("/poster-recipients", { emails: list });
      setEmails(data.emails);
      setDraft("");
      toast.success("Destinataires enregistrés");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Adresse invalide");
    }
  };

  return (
    <section className="rounded-2xl border border-border bg-card p-6" data-testid="poster-mail-section">
      <h2 className="mb-1 flex items-center gap-2 font-display text-lg font-bold"><Mail className="h-5 w-5 text-primary" /> Envoi des affiches</h2>
      <p className="mb-4 text-sm text-muted-foreground">Les affiches sont envoyées en image A4 paysage à ces adresses.</p>
      <div className="mb-3 flex flex-wrap gap-2">
        {emails.map((e) => (
          <span key={e} className="flex items-center gap-1 rounded-full bg-secondary px-3 py-1 text-sm" data-testid={`recipient-${e}`}>
            {e}
            <button onClick={() => save(emails.filter((x) => x !== e))} title="Retirer" data-testid={`remove-recipient-${e}`}><X className="h-3.5 w-3.5" /></button>
          </span>
        ))}
        {!emails.length && <span className="text-sm text-muted-foreground">Aucun destinataire</span>}
      </div>
      <div className="mb-6 flex gap-2">
        <Input type="email" value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="adresse@exemple.com"
          onKeyDown={(e) => e.key === "Enter" && draft.trim() && save([...emails, draft.trim()])} data-testid="recipient-input" />
        <Button onClick={() => save([...emails, draft.trim()])} disabled={!draft.trim()} data-testid="add-recipient-button"><Plus className="mr-1 h-4 w-4" /> Ajouter</Button>
      </div>
      <div className="space-y-2">
        {posters.map((p) => (
          <div key={p.id} className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-border px-3 py-2" data-testid={`mail-poster-row-${p.id}`}>
            <span className="text-sm font-medium">{p.name}</span>
            <SendPosterButton poster={p} />
          </div>
        ))}
        {!posters.length && <p className="text-sm text-muted-foreground">Aucune affiche</p>}
      </div>
    </section>
  );
};
